import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn } from '@angular/router';
import { environment } from '../../../environments/environment';

export const platformAdminLoginRedirectGuard: CanActivateFn = () => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return false;
  }

  const currentUrl = new URL(window.location.href);
  const target = new URL('/login', environment.platformAdminAppUrl);
  const returnUrl = currentUrl.searchParams.get('returnUrl');
  if (returnUrl) {
    target.searchParams.set('returnUrl', returnUrl);
  }

  window.location.replace(target.toString());
  return false;
};
